export default __webpack_public_path__ + "static/media/jstips-animation.5f86c266.gif";